import {selectNavOption} from "../helpers/nav_option_helpers";
import {selectExperienceMarker} from "../helpers/experience_marker_helpers";
import {clearExperienceMarker, clearNavOption, setRenderMapBounds} from "../helpers/commit_helpers";
import {requestNavClose} from "../helpers/nav_helpers";

export default function filterExperienceRouteRequested(sm, payload) {
    const experience = payload.experience;
    const mapFilter = payload.mapFilter;

    const navOption = mapFilter?.onlineAppNavOption;
    const experienceMarker = experience?.experienceMarker;

    if (navOption) {
        // The navOption may have map bounds (triggering a map pan/zoom).
        // When a filter experience route is requested we don't wish for this to happen.
        // So we temporarily true off the rendering of map bounds.
        setRenderMapBounds(sm, false);
        selectNavOption(sm, navOption);
        setRenderMapBounds(sm, true);
        // On the INITIAL deep-link resolution, preserve the Nav's restored persisted navOpen rather
        // than apply this option's nav-toggle instruction (plan 2026-07-20 follow-up). Note the
        // explicit requestNavClose() below is separate — a deep link to a specific experience
        // deliberately closes the nav to reveal that experience on the map, initial load or not.
        navOption.fireSelectedWithRouteRequestEvent({ isInitialRoute: sm.getStateableObject().hasPendingInitialRoute() }); // Event to be picked up by Nav's PaneOptionComponent event listener.
    } else {
        if(isCurrentNavOption(sm)) clearNavOption(sm);
    }

    if (experienceMarker) {
        selectExperienceMarker(sm, mapFilter, experienceMarker);
        // Don't force-close on the INITIAL deep-link resolution — the Nav's restored persisted
        // navOpen must stand (plan 2026-07-20 follow-up). In-session navigation to an experience
        // still closes the nav to reveal the marker.
        if (!sm.getStateableObject().hasPendingInitialRoute()) {
            requestNavClose(); // Request the Nav to close (it owns navOpen); reflected back as navOpenReflected.
        }
    } else {
        if(isCurrentExperienceMarker(sm)) clearExperienceMarker(sm);
    }


}

// Private…

function isCurrentExperienceMarker(sm) {
    return !!sm.state['experienceMarker'];
}

function isCurrentNavOption(sm) {
    return !!sm.state['navOption'];
}